import { EstateDesignType } from "@1games-ru/region-shared/dist/enums/estate/estate";
import { useCallback } from "react";
import EstateMpProvider from "@/core/data-provider/data-mp/estate/estate-mp-provider.ts";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector.ts";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import {
  estateSelector,
  setDesignPreviewEnabled,
  setDesignVariants,
  setSelectedDesignVariant,
} from "@/domains/estate/slice";

export default () => {
  const dispatch = useAppDispatch();
  const estate = useAppSelector(estateSelector);

  const loadDesign = useCallback(async () => {
    const response = await EstateMpProvider.getDesignVariants(estate.id);
    if (response instanceof RpcMpProviderSuccessResponse) {
      dispatch(setSelectedDesignVariant(null));
      dispatch(setDesignPreviewEnabled(response.data.isInside));
      dispatch(
        setDesignVariants(
          response.data.items.map((item) => {
            const activeInteriorId =
              item.type === EstateDesignType.Wall
                ? response.data.values.walls
                : response.data.values.furniture;

            return {
              ...item,
              isActive: item.interiorPropId === activeInteriorId,
            };
          }),
        ),
      );
    } else {
      // TODO: уводемить об ошибке
      console.log("load design variants:", response);
    }
  }, [dispatch, estate]);

  return {
    loadDesign,
  };
};
